import styles from '../styles/Footer.module.scss';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import Gradient from "../imgs/gradient.svg";
import Gradient2 from "../imgs/gradient2.svg";

export default function Footer() {
    const { t } = useTranslation();

    return (
      <div>
          <div className={styles.header}>
      <img className={styles.gradient_top} src={Gradient2} alt="gradient" />
        <div className={styles.info}>
          <h1>
            {t("Your Path to ")}
            <span>{t("Financial")}</span>
            {t(" Success")}
          </h1>
          <div className={styles.block}>
            <span>
              {t(
                "Low minimum deposits, low spreads and additional bonuses when depositing create profitable conditions for trading. And a wide range of payment systems helps to perform financial operations quickly and comfortably."
              )}
            </span>
            <div>
              <Link to="/login">{t("Login")}</Link>
              <Link to="/register">{t("Registration")}</Link>
            </div>
            <span>
              {t(
                "Interactiveassets ist die exklusive Handelsplattform des Unternehmens Baden-Württembergische Wertpapierbörse. Am Börsenplatz Stuttgart ist die Baden-Württembergische Wertpapierbörse GmbH die privatrechtliche Trägergesellschaft für die Baden-Württembergische Wertpapierbörse. Der Börsenträger Baden-Württembergische Wertpapierbörse GmbH ist eine hundertprozentige Tochtergesellschaft der Vereinigung Baden-Württembergische Wertpapierbörse e.V. und damit eine der Einheiten der Gruppe Börse Stuttgart. Anbieter: Boerse Stuttgart GmbH, Börsenstraße 4, 70174 Stuttgart, Registergericht: Amtsgericht Stuttgart HRB Nr. 753383 Umsatzsteueridentifikationsnummer: Ust-IdNr. DE 200902198"
              )}
            </span>
          </div>
        </div>
        {/* <img className={styles.gradient_bottom} src={Gradient} alt="gradient" /> */}
      </div>
        <div className={styles.footer}>


        <div className={styles.top}>
          <Link to='/accounts'>{t("Account Types")}</Link>
          <Link to='/tools/forexHeatMap'>{t("Instruments")}</Link>
          <Link to='/bonuses'>{t("Promotion and bonuses")}</Link>
          <Link to='/about'>{t("About us")}</Link>
          <span className={styles.left_side}>
              {t("© 2024 Interactive Assets")}
            </span>
        </div>
        {/* {window.innerWidth > 600 ? (
          <div className={styles.bottom}>
            <span className={styles.left_side}>
              {t("© 2024 Interactive Assets")}
            </span>
            <div className={styles.right_side}>
              <span>{t("All Rights Reserved")}</span>
              <span>{t("Privacy Notice")}</span>
              <span>{t("Legal")}</span>
              <span>{t("Site map")}</span>
            </div>
          </div>
        ) : (
          <div className={styles.bottom}>
            <div className={styles.right_side}>
              <span>{t("All Rights Reserved")}</span>
              <span>{t("Privacy Notice")}</span>
              <span>{t("Legal")}</span>
              <span>{t("Site map")}</span>
            </div>
            <span className={styles.left_side}>
              {t("© 2024 Interactive Assets")}
            </span>
          </div>
        )} */}
      </div>
      </div>
    )
}